import { BusinessEntity, MotorCarriersService } from '@/@types/generated'
import { hasFeature } from '@/components/Atoms/Permissions'
import { useAuth } from '@/hooks/useAuth'
import { CertificatesFeature } from '@/lib/features'
import { RevealButton } from '@/modules/licensing-agencies/components/RevealButton'

interface Mcs150EmailRevealProps {
  businessEntity: BusinessEntity
}

// Shows the carrier's live MCS-150 email (masked/reveal) when available, otherwise the
// AV registration's primary contact email for AV-only entities with no motor carrier.
export function Mcs150EmailReveal({ businessEntity }: Mcs150EmailRevealProps) {
  const { user } = useAuth()
  const canReveal = hasFeature(CertificatesFeature.ViewMcs150Email, user)

  const carrierId = businessEntity.motorCarrier?.id
  const email = businessEntity.motorCarrier?.mcs150Email
  if (carrierId && email) {
    return (
      <RevealButton
        canReveal={canReveal}
        getSecret={() => MotorCarriersService.getMcs150Email(carrierId)}
      >
        {email}
      </RevealButton>
    )
  }

  return <>{businessEntity.autonomousVehicleContact?.email ?? '—'}</>
}
